import React from "react";
import { Container, Button } from "react-bootstrap";
import { MdRocketLaunch } from "react-icons/md";
import { useDispatch } from "react-redux";
import {
  batchEnd,
  batchLoading,
  batchMessage,
  batchStart,
  setFilterText,
  setLoading,
} from "../../../../redux/features/ui/uiSlice";
import { useSelector } from "react-redux";
import { getCurrentTab, getDialog, getFilters } from "../../../../redux/selectors";
import execBatch from "../../../../services/execBatch";
import batchStatus from "../../../../services/batchStatus";
import { setError } from "../../../../redux/features/modals/modalsSlice";

const TopBarOnDialog = ({ tabID }) => {
  const dispatch = useDispatch();
  const batchStarted = useSelector((state) => getCurrentTab(state, tabID).batchStart);
  const filters = useSelector((state) => getFilters(state, tabID));
  const dialog = useSelector((state) => getDialog(state, tabID));
  const [reqID, setReqID] = React.useState(undefined);

  React.useEffect(() => {
    var intervalId;
    if (reqID) {
      intervalId = setInterval(async () => {
        const status = await batchStatus(reqID);
        console.log(status);
        if (status.status == "done") {
          dispatch(setLoading({ show: false, tabID: tabID }));
          dispatch(batchLoading({ value: true, tabID: tabID }));
          dispatch(batchEnd({ tabID: tabID }));
          dispatch(batchMessage({ tabID: tabID, value: status.data }));
          clearInterval(intervalId);

          // status.data != '""' && dispatch(setError({ message: status.data, show: true }));
        }
      }, 2 * 1000);
    }
    return () => clearInterval(intervalId);
  }, [reqID]);

  const execBatchJob = async () => {
    dispatch(setLoading({ show: true, tabID: tabID }));
    dispatch(batchLoading({ value: true, tabID }));
    dispatch(batchStart({ tabID }));
    var text = "";
    if (filters?.data) {
      for (const [tablename] of Object.entries(filters.data)) {
        for (const [field, value] of Object.entries(filters.data[tablename])) {
          console.log(filters);
          console.log(tabID);
          console.log(dialog);
          console.log(tablename);
          const isMemory = dialog.model[tablename].fields.find((item) => item.name == field).editType == "MemoryTable";
          text +=
            value != ""
              ? text != ""
                ? `&${tablename}.${field}=${isMemory ? value.split("|")[0] : value}`
                : `${tablename}.${field}=${isMemory ? value.split("|")[0] : value}`
              : "";
        }
      }
    }
    dispatch(setFilterText({ value: text, tabID }));
    const batch = await execBatch(tabID);
    setReqID(batch.reqID);

    console.log(batch);

    // dispatch(setLoading({ show: false, tabID }));
  };
  return (
    <Container fluid className="object-top-bar">
      <Button variant="secondary" onClick={execBatchJob}>
        <MdRocketLaunch size="1.2rem" />
      </Button>
      {batchStarted && (
        <Button variant="secondary" onClick={() => dispatch(batchLoading({ value: true, tabID }))}>
          <span>Αποτελέσματα</span>
        </Button>
      )}
    </Container>
  );
};

export default TopBarOnDialog;
